// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FF-scroll-modify {
    height: 66vh !important;
    overflow-x: hidden;
    overflow-y: scroll;
    margin-top: 20px;
}
.video-container:hover {
    background-color: #f8f9fa;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);
    /*border-radius: 10px;*/
}

.video-container:hover .published-options {
    display: block;
    width: 100%;
}

.published-option-active {
    display: block !important;
}

.video-container:hover .published-options {
    display: block !important;
}
.img-box-pub {
    aspect-ratio: 16/9;
    display: flex;
    justify-content: center;
    /*height: 213px;*/
    position: relative;
    overflow: hidden;
    background: #f8f9fa;
    border-radius: 16px;
    width: 100%;
}

.img-box-pub img {
    height: 100%;
    object-fit: cover;
}
.activity-textbox p {
    padding: 1px 0;
    margin: 0 8px;
    font-weight: 400;
    font-size: 14px;
    color: #727272;
}

.activity-textbox .sharedby {
    padding: 1px 0;
    font-weight: 400;
    font-size: 14px;
    color: #727272;
}

.activity-textbox h4 {
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 400;
    color: #0f062b;
}

.activity-textbox .more-images {
    background: #F5F5F5 !important;
    border: 1px solid #727272 !important;
    color: #727272;
}
.margin-zero p {
    margin: 0 !important;
    font-size: 16px;
        color: black;
}
.group-box {
    padding: 0 20px 20px;
    border-radius: 16px;
    background-color: #ffff;
    position: relative;
}
.groupName{
    font-size: 20px;
    font-weight:500;
    margin-bottom: 0;
}


.group-detail{
    padding-block: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
  }
  .group-detail img{
    object-fit: contain;
    background: #ededed;
    border-radius: 10px;
  }
  

@media (max-width: 1600px) {
    .img-box-pub {
        height: 185px
    }
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/group/group-analytics/group-analytics.component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,8CAA8C;IAC9C,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,cAAc;AAClB;AACA;IACI,oBAAoB;IACpB,eAAe;QACX,YAAY;AACpB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;EACrB;;;AAGF;IACI;QACI;IACJ;AACJ","sourcesContent":[".FF-scroll-modify {\n    height: 66vh !important;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    margin-top: 20px;\n}\n.video-container:hover {\n    background-color: #f8f9fa;\n    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);\n    /*border-radius: 10px;*/\n}\n\n.video-container:hover .published-options {\n    display: block;\n    width: 100%;\n}\n\n.published-option-active {\n    display: block !important;\n}\n\n.video-container:hover .published-options {\n    display: block !important;\n}\n.img-box-pub {\n    aspect-ratio: 16/9;\n    display: flex;\n    justify-content: center;\n    /*height: 213px;*/\n    position: relative;\n    overflow: hidden;\n    background: #f8f9fa;\n    border-radius: 16px;\n    width: 100%;\n}\n\n.img-box-pub img {\n    height: 100%;\n    object-fit: cover;\n}\n.activity-textbox p {\n    padding: 1px 0;\n    margin: 0 8px;\n    font-weight: 400;\n    font-size: 14px;\n    color: #727272;\n}\n\n.activity-textbox .sharedby {\n    padding: 1px 0;\n    font-weight: 400;\n    font-size: 14px;\n    color: #727272;\n}\n\n.activity-textbox h4 {\n    margin-bottom: 0;\n    font-size: 16px;\n    font-weight: 400;\n    color: #0f062b;\n}\n\n.activity-textbox .more-images {\n    background: #F5F5F5 !important;\n    border: 1px solid #727272 !important;\n    color: #727272;\n}\n.margin-zero p {\n    margin: 0 !important;\n    font-size: 16px;\n        color: black;\n}\n.group-box {\n    padding: 0 20px 20px;\n    border-radius: 16px;\n    background-color: #ffff;\n    position: relative;\n}\n.groupName{\n    font-size: 20px;\n    font-weight:500;\n    margin-bottom: 0;\n}\n\n\n.group-detail{\n    padding-block: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 15px;\n  }\n  .group-detail img{\n    object-fit: contain;\n    background: #ededed;\n    border-radius: 10px;\n  }\n  \n\n@media (max-width: 1600px) {\n    .img-box-pub {\n        height: 185px\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
